import { DataType, ModificationSetting, Tool, ToolJob, ToolParam, UserInfo } from './tool.models';

export type Toolchain = {
  toolchainId: number;
  name: string;
  displayName: string;
  description: string;
  icon: string;
  author: string;
  steps: ToolchainStepConfig[];
  tools: Record<string, Tool>;
  created: string;
  modified: string;
  project: string;
  toolchainVersion: string;
};

export type ToolchainStepConfig = {
  stepNo: number;
  stepDescription: string;
  toolId: number;
  inputMapping: InputMapping[];
  automaticStart: boolean;
};

export type InputMapping = {
  inputName: string;
  outputName: string;
  isSelectable: boolean;
  isModifiable: boolean;
  isHidden?: boolean;
  modifications?: Partial<ModificationSetting>;
};

export type ToolInput = ToolParam | InputWithMapping;

export type InputWithMapping = ToolParam & {
  valueToMap: DataType | DataType[];
  isHidden: boolean;
  isSelectable: boolean;
  isModifiable: boolean;
  modifications?: Partial<ModificationSetting>;
};

export function isInputWithMapping(input: ToolInput): input is InputWithMapping {
  return (input as InputWithMapping).valueToMap !== undefined;
}

export type ToolchainJob = {
  toolchainJobId: number;
  toolchain: Pick<Toolchain, 'toolchainId'>;
  userId: number;
  status: ToolchainJobStatus;

  created: string;
  started?: string;
  modified: string;

  currentStep: number;
  totalSteps: number;
  toolJobs: ToolJob[];
};

export type ToolchainJobStatus = 'Done' | 'Started' | 'Error' | 'Running' | 'Action required';

export type ToolchainRegistration = {
  created: string;
  isActive: boolean;
  modified: string;
  registrationId: number;
  toolchain: Toolchain;
  user: UserInfo;
};

export type ToolchainUsersRegistration = {
  toolchain: Toolchain;
  users: UserInfo[];
};
